import * as Yup from 'yup';
import moment from 'moment';

export const filtrosSchema = Yup.object().shape({
  codigo_grupo_empresa: Yup.number()
    .typeError('Selecione o Grupo de Empresa')
    .required('Selecione o Grupo de Empresa')
    .positive('Selecione o Grupo de Empresa')
    .integer('Selecione o Grupo de Empresa'),
  codigo_conta: Yup.number()
    .typeError('Selecione a Conta de Caixa')
    .required('Selecione a Conta de Caixa')
    .positive('Selecione a Conta de Caixa')
    .integer('Selecione a Conta de Caixa'),
  codigo_ativo: Yup.number()
    .typeError('Selecione a Moeda')
    .required('Selecione a Moeda')
    .positive('Selecione a Moeda')
    .integer('Selecione a Moeda'),
  dt_inicial: Yup.string()
    .required('Data inicial obrigatória')
    .matches(/^\d{2}\/\d{2}\/\d{4}$/, 'Data inicial inválida')
    .test('valid-date', 'Data inicial inválida', (value) =>
      value ? moment(value, 'DD/MM/YYYY', true).isValid() : false
    )
    .test('nao-futura', 'Data não pode ser futura', (value) => {
      if (!value) return true;
      const d = moment(value, 'DD/MM/YYYY', true);
      return d.isValid() ? d.isSameOrBefore(moment(), 'day') : true;
    })
    .test('nao-antiga', 'Data muito antiga', (value) => {
      if (!value) return true;
      const d = moment(value, 'DD/MM/YYYY', true);
      const minimo = moment('2000-01-01', 'YYYY-MM-DD');
      return d.isValid() ? d.isSameOrAfter(minimo, 'day') : true;
    }),
});

export const observacaoSchema = Yup.object()
  .shape({
    observacao1: Yup.string().max(50, 'Máximo 50 caracteres'),
    observacao2: Yup.string().max(50, 'Máximo 50 caracteres'),
    observacao3: Yup.string().max(50, 'Máximo 50 caracteres'),
  })
  .test('ao-menos-uma', 'Informe ao menos uma observação', (val) => {
    if (!val) return false;
    const o1 = (val.observacao1 || '').trim();
    const o2 = (val.observacao2 || '').trim();
    const o3 = (val.observacao3 || '').trim();
    return Boolean(o1 || o2 || o3);
  });
